import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { useAccount } from '@/hooks/useAccount';
import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import { OnboardingNavigation } from '@/pages/Onboarding/components/Navigation';
import { OnboardingPage } from '@/pages/Onboarding/components/Page';
import { useOnboarding } from '@/pages/Onboarding/context';
import { OwnAiTitle } from '@/pages/Onboarding/Layouts/OwnAI/components/Title';
import { OUTNESS_OPTIONS } from '@/pages/Onboarding/options/Outness/OUTNESS_OPTIONS';
import { getOutnessTitleById } from '@/pages/Onboarding/options/Outness/utils/getOutness';
import { OnbOptionType } from '@/pages/Onboarding/types';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';

import {
  PurpleOptions,
  PurpleOptionItem,
} from '../../components/PurpleOptions';
import { LayoutDataType } from '../../types';

export const OutnessScreen: React.FC = () => {
  const { user } = useAccount();

  React.useEffect(() => {
    if (user && canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'Outness',
      });
    }
  }, [user]);

  const { wizard } = useOnboarding();

  const form = useFormContext<LayoutDataType>();

  const outness = form.watch('outness');

  const handleSelect = (option: OnbOptionType<LayoutDataType['outness']>) => {
    form.setValue('outness', option.id);
  };

  const handleNextStep = () => {
    const outnessTitle = getOutnessTitleById(outness);
    userService.createOrUpdate({
      onboarding_data: {
        outness: outnessTitle,
      },
    });
    wizard.nextStep();
  };

  return (
    <OnboardingPage background={'purple-gradient'}>
      <OnboardingNavigation />
      <OwnAiTitle>How Open Is He? (Outness)</OwnAiTitle>

      <IonContent>
        <PurpleOptions displayType="list">
          {OUTNESS_OPTIONS.map((option) => (
            <PurpleOptionItem
              checked={outness === option.id}
              control={form.control}
              option={option}
              name="outness"
              key={option.id}
              onChange={() => handleSelect(option)}
              displayType="list"
            />
          ))}
        </PurpleOptions>
      </IonContent>
      <OnboardingFooter
        onContinue={handleNextStep}
        buttonColor={'purple-gradient'}
        buttonRadius={'sm'}
        buttonSize={'large'}
        buttonClassName={'page-footer'}
        disabled={!outness}
      />
    </OnboardingPage>
  );
};
